export const generateDashboard = `
  mutation GenerateDashboard($input: DashboardInput!) {
    generateDashboard(input: $input) {
      folderName
      images {
        name
        url
      }
      csvUrl
      message
      articlesCsv
      articlesJson
      dataTimestamp
    }
  }
`;
